import { Button, Form, FormGroup, Input, Spinner } from "reactstrap";
import { ChangeEvent, useContext, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import { UserProps } from "../context/hooks/useAuth";

const Login = () => {
  const { handleLogin, setSelectTypeUser, selectTypeUser } =
    useContext(AuthContext);

  const [login, setLogin] = useState<UserProps>({ password: "", email: "" });
  const [loading, setLoading] = useState(false);

  const handleLoginClick = async () => {
    setLoading(true);
    await handleLogin(login);
    setLoading(false);
  };

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setLogin((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="login-form">
      <h2 className="login-form__title">
        {selectTypeUser === 2 ? "Seja Bem-Vindo, Recrutador" : "Seja Bem-Vindo, Candidato"}
      </h2>
      <img
        className="login-form__logo"
        alt="Logo"
        src={require("../assets/img/brand/Marca-2.png")}
      />

      <Form role="form" className="login-form__fields">
        <FormGroup>
          <Input
            name="email"
            placeholder="Email"
            type="email"
            autoComplete="email"
            value={login.email}
            onChange={handleInputChange}
            className="login-form__input"
          />
        </FormGroup>
        <FormGroup>
          <Input
            name="password"
            placeholder="Senha"
            type="password"
            autoComplete="current-password"
            value={login.password}
            onChange={handleInputChange}
            className="login-form__input"
          />
        </FormGroup>

        <div className="login-form__type-switcher">
          <button
            type="button"
            className={`login-form__type-btn${selectTypeUser === 1 ? " login-form__type-btn--active" : ""}`}
            onClick={() => setSelectTypeUser(1)}
          >
            Candidato
          </button>
          <button
            type="button"
            className={`login-form__type-btn${selectTypeUser === 2 ? " login-form__type-btn--active" : ""}`}
            onClick={() => setSelectTypeUser(2)}
          >
            Recrutador
          </button>
        </div>

        <Button
          onClick={handleLoginClick}
          type="button"
          disabled={loading}
          className="login-form__submit"
        >
          {loading && <Spinner size="sm">Loading...</Spinner>}
          {" "}Entre
        </Button>
      </Form>
    </div>
  );
};

export default Login;
